import { TOOL_COUNT, WRITE_COUNT } from '../data/tools';

const ITEMS = [
    {
        title: 'Read-only by design',
        text: `${TOOL_COUNT - WRITE_COUNT} of ${TOOL_COUNT} tools only read. The ${WRITE_COUNT} that write are append-only actions the passenger asks for explicitly and are annotated as such for the model.`
    },
    {
        title: 'Signed in with Miles&Smiles',
        text: 'Clients authorize through an OAuth 2.1 authorization-code flow with PKCE. The login itself adds Cloudflare Turnstile and a one-time code where the account requires it.'
    },
    {
        title: 'Nothing is stored about you',
        text: 'No profiles, no conversation history. Tokens hold only what is needed to call Turkish Airlines on your behalf, encrypted with keys derived from the token itself.'
    },
    {
        title: 'Validated, audited, monitored',
        text: 'Every input and output is checked against a schema. Calls are logged for abuse detection, latency is measured, and the service alerts before passengers notice.'
    }
];

export function Trust() {
    return (
        <section id="trust" className="tkh-section" aria-labelledby="trust-title" data-reveal>
            <div className="tkh-wrap">
                <p className="tkh-eyebrow">Safety card</p>
                <h2 id="trust-title" className="tkh-h2">
                    Built to be trusted with a booking.
                </h2>
                <div className="tkh-trust-grid">
                    {ITEMS.map((item, i) => (
                        <div className="tkh-trust" key={item.title} style={{ '--i': i } as React.CSSProperties}>
                            <div className="num">0{i + 1}</div>
                            <h3>{item.title}</h3>
                            <p>{item.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
